/** Title-row overflow actions for index surfaces (one `...`, never a filter-row copy). */

export const INDEX_PANEL_SEARCH_EVENT = 'flownotes:index-panel-search'
export const INDEX_VIEW_ACTION_EVENT = 'flownotes:index-view-action'

export type IndexViewAction =
  | 'listening'
  | 'open-external'
  | 'reload-list'
  | 'refresh-membership'
  | 'refresh-visible'

export function dispatchIndexPanelSearch(): void {
  window.dispatchEvent(new CustomEvent(INDEX_PANEL_SEARCH_EVENT))
}

export function dispatchIndexViewAction(action: IndexViewAction): void {
  window.dispatchEvent(new CustomEvent(INDEX_VIEW_ACTION_EVENT, { detail: { action } }))
}

export function indexViewActionFromEvent(event: Event): IndexViewAction | null {
  const action = (event as CustomEvent<{ action?: IndexViewAction }>).detail?.action
  if (
    action === 'listening' ||
    action === 'open-external' ||
    action === 'reload-list' ||
    action === 'refresh-membership' ||
    action === 'refresh-visible'
  ) {
    return action
  }
  return null
}
